import cn from 'classnames';

type AvatarSize = 'xs' | 's' | 'm' | 'l' | 'xl';

export interface AvatarProps {
  size?: AvatarSize;
  src?: string;
}

function getAvatarSize(size: AvatarSize) {
  switch (size) {
    case 'xs':
      return 'h-6 w-6';
    case 's':
      return 'h-8 w-8';
    case 'm':
      return 'h-10 w-10';
    case 'l':
      return 'h-12 w-12';
    case 'xl':
      return 'h-14 w-14';
  }
}

export function Avatar({ size = 'm', src }: AvatarProps) {
  return (
    <span
      className={cn(
        'inline-block rounded-full overflow-hidden bg-gray-100',
        getAvatarSize(size),
      )}
    >
      {src ? (
        <img src={src} />
      ) : (
        <svg
          className="h-full w-full text-gray-300"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )}
    </span>
  );
}

export default Avatar;
